import { render, staticRenderFns } from "./OrganizationsTransactionList.vue?vue&type=template&id=2aa262fa&scoped=true"
import script from "./OrganizationsTransactionList.vue?vue&type=script&lang=js"
export * from "./OrganizationsTransactionList.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsTransactionList.vue?vue&type=style&index=0&id=2aa262fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa262fa",
  null
  
)

export default component.exports